<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },

  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    clearNotification: notificationMethods.clear,
  },
};
</script>

<template>
  <div id="app">
    <RouterView v-if="isRouterAlive" />
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// .tox-silver-sink{
//   z-index: 3333 !important;
// }
body,
form,
div,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
table,
tr,
th,
td,
p,
input,
dl,
dt,
dd,
ul,
ol,
li {
  font-family: "微软雅黑", "Microsoft YaHei", "苹果苹方", "PingFang SC", Arial,
    "宋体", "SimSun", "黑体", "SimHei", "sans-serif", "Helvetica Neue",
    "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    "Noto Color Emoji" !important;
}

input,
textarea {
  font-family: "苹果苹方", "PingFang SC", Arial, "黑体", "Heiti SC", "SimHei",
    "宋体", "SimSun", "Songti SC", "SimSong", "微软雅黑", "Microsoft YaHei",
    "sans-serif", "Helvetica Neue", "Noto Sans", "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
.newTopic {
  .el-dialog__body {
    max-height: calc(100vh - 200px) !important;
    overflow: auto;
  }
}

.el-tabs--card > .el-tabs__header {
  border-bottom: 1px solid #ced4da !important;
  margin: 0 !important;
}
/* .el-tabs__header{
  margin-bottom: 0px !important;
} */
.card-body {
  padding-bottom: 0 !important;
}
.el-table .cell div span {
  white-space: pre-wrap;
}
.optWrap span {
  white-space: inherit !important;
}
.t-table__body td span {
  white-space: pre-wrap;
}
.table > :not(caption) > * > * {
  padding: 0.75rem 1rem !important;
}
.bath_r_20 .form-select {
  margin-left: 1rem;
}

.page-content {
  padding-top: 70px;
  padding-left: 0;
  padding-right: 0;
}
.container-fluid {
  padding: 0;
}
.mg-top-1 {
  margin-top: 1rem;
}
.pad-top-1-25 {
  padding-top: 1.25rem;
}
.pad-header-bg {
  background-color: #f3f3f9;
  padding: 1rem;
}
.pad-header-bg .form-control {
  width: 190px;
}
.header-item-fix {
  display: flex;
  float: right;
  margin-left: 10px;
}
.header-item-fix button {
  margin-left: 3px;
}
.header-item-fix button i {
  margin-top: -1px;
}
.pad-header-bg select {
  width: 190px;
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
  outline: none;
}

.select-sm {
  width: 190px;
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
  outline: none;
}

.dsply-fix {
  display: flex;
}

.m-r-5 {
  margin-right: 5px;
}

.m-r-10 {
  margin-right: 10px;
}

.m-r-20 {
  margin-right: 20px;
}

.m-r-30 {
  margin-right: 30px;
}

.m-r-40 {
  margin-right: 40px;
}

.m-r-50 {
  margin-right: 50px;
}
.el-pagination__jump{
  margin: 0 10px!important;
}


.w-3-rem {
  width: 3rem;
  height: 3rem;
}
.w-16-9-rem {
  height: 3rem;
  width: 5.33rem;
  object-fit: cover;
}
.w-1-1-rem {
  height: 3rem;
  width: 3rem;
  object-fit: cover;
}
.w-22-9-rem {
  height: 3rem;
  width: 7.33rem;
  object-fit: cover;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #556ee6 !important;
  font-size: 0.8125rem !important;
}
.el-radio__label {
  font-size: 0.8125rem !important;
  padding-left: 5px !important;
}
.el-radio__input.is-checked .el-radio__inner {
  background: #556ee6 !important;
  border-color: #556ee6 !important;
}
.submit-bar {
  margin-top: 0.5rem;
  padding-top: 1.25rem;
  padding-right: 1rem;
  border-top: 1px solid #ced4da;
}

.submit-bar .bar-handle {
  display: flex;
  float: right;
}

.submit-bar .bar-handle button {
  margin-left: 1rem;
}

.pd-rl-1 {
  padding-left: 1.6rem;
  padding-right: 1.6rem;
}

.m-t-20 {
  margin-top: 20px;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}
.w-190 {
  width: 190px;
}

.app-list-sort i {
  font-size: 30px;
  cursor: pointer;
}

.form-check {
  margin-bottom: 0;
}

.w-3-rem {
  width: 3rem;
  height: 3rem;
}

.status-open,
.status-off,
.status-over {
  cursor: pointer;
  float: left;
}

.status-open i {
  width: 8px;
  height: 8px;
  background: #0edd4d;
  border-radius: 50%;
  display: block;
  margin-top: 5px;
  margin-right: 5px;
}
.status-over i {
  width: 8px;
  height: 8px;
  background: #f1b44c;
  border-radius: 50%;
  display: block;
  margin-top: 5px;
  margin-right: 5px;
}

.status-off i {
  width: 8px;
  height: 8px;
  background: #dd0e0e;
  border-radius: 50%;
  display: block;
  margin-top: 5px;
  margin-right: 5px;
}

.list-header .el-select {
  min-width: 190px;
  min-height: calc(1.5em + 0.5rem + 2px);
}

.list-header .el-select .el-input__inner {
  min-width: 100%;
  min-height: 100%;
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
  outline: none;
  color: #495057;
  line-height: 1.5;
  border: 1px solid #ced4da !important;
  height: calc(1.5em + 0.5rem + 3px) !important;
}

.list-header .el-select .el-select__input {
  font-size: 0.7109375rem;
  color: #495057;
  margin-left: 0;
  padding-left: 0.5rem;
}

.list-header .el-select .el-input__inner::-webkit-input-placeholder {
  color: #74788d;
}
.list-header .el-select .el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #74788d;
}
.list-header .el-select .el-input__inner:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #74788d;
}
.list-header .el-select .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #74788d;
}

.list-header .el-select > .el-input {
  position: absolute;
  top: 0;
  left: 0;
}

.list-header .el-select .el-input .el-select__caret {
  color: #495057;
  font-weight: bold;
  line-height: 2.1;
}

.list-header .el-select .el-select__tags {
  width: auto !important;
  max-width: none !important;
  position: relative;
  z-index: 1;
  top: initial;
  -webkit-transform: initial;
  transform: initial;
}

.list-header .fix-header-item select {
  width: 190px;
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
  outline: none;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #556ee6 !important;
}

.el-select-dropdown__item {
  font-size: 13px;
  height: 30px;
  line-height: 30px;
}

.m-400 {
  max-width: 400px;
}

.m-300 {
  max-width: 300px;
}

.m-200 {
  max-width: 200px;
}

.w-200px {
  width: 200px;
}

.w-300px {
  width: 300px;
}

.w-100 {
  max-width: 100px;
}

.w-200 {
  max-width: 200px;
}

.w-300 {
  max-width: 300px;
}

.white-inherit {
  white-space: inherit;
  text-align: justify;
  text-justify: newspaper;
  word-break: break-all;
  white-space: inherit !important;
}

.el-dialog {
  border-radius: 6px !important;
  margin-top: 0 !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  -webkit-transform: translateX(-50%) translateY(-50%) !important;
  -moz-transform: translateX(-50%) translateY(-50%) !important;
  -ms-transform: translateX(-50%) translateY(-50%) !important;
  transform: translateX(-50%) translateY(-50%) !important;
  max-height: 95vh !important;
}

.swal2-container {
  z-index: 9999 !important;
}
.swal2-styled.swal2-confirm {
  background-color: #556ee6 !important;
}

.app-list-sort .dropdown-toggle {
  background-color: transparent !important;
  border-color: none !important;
  border: none !important;
  outline: none;
  padding: 0 !important;
  box-shadow: none !important;
}

.app-list-sort .dropdown-toggle .bx-filter-alt {
  color: #495057;
}

.app-list-sort .dropdown-menu {
  left: inherit !important;
  right: 0 !important;
}

.app-list-sort .dropdown-item i {
  margin-right: 5px;
}

.app-list-sort .dropdown-item .padleft {
  padding-left: 23px;
}

.select-tabs .alert {
  padding: 0;
  line-height: 1.5;
  padding: 0.47rem 0.4rem 0.47rem 0.75rem;
  font-size: 0.8125rem;
  border-radius: 0.25rem;
  margin-bottom: 0px;
}

.select-tabs .alert span {
  margin-left: 10px;
  cursor: pointer;
}

.select-tabs .alert span i {
  font-weight: bold;
}

.card-body .card-body-form {
  position: relative;
}

.card-body .card-body-form .page-transparent-bg {
  position: absolute;
  /*background-color: transparent;*/
  background-color: rgb(192, 196, 204, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.card-body .app-disabled-main {
  position: relative;
}

.card-body .app-disabled-main .disabled-main-bg {
  position: absolute;
  /*background-color: transparent;*/
  background-color: rgb(192, 196, 204, 0.5);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
div,
textarea {
  resize: none;
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", "微软雅黑",
    sans-serif !important;
}

.mg-b-no {
  margin-bottom: 0;
}

/*********************** el-tabs css *****************************/

.el-tabs--card > .el-tabs__header {
  border-bottom: 1px solid #ced4da !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
  margin-bottom: 0px;
  margin-top: 1px;
  margin-left: 1px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  color: #495057;
  font-weight: 500;
  font-size: var(--bs-body-font-size);
  padding: 0 1.1rem !important;
  box-sizing: border-box;
  margin: -1px;
  border: 1px solid transparent !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__item:hover {
  color: #556ee6;
  border-top: 1px solid rgba(206, 212, 218, 0.3) !important;
  border-left: 1px solid rgba(206, 212, 218, 0.3) !important;
  border-right: 1px solid rgba(206, 212, 218, 0.3) !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-top: 1px solid #ced4da !important;
  border-left: 1px solid #ced4da !important;
  border-right: 1px solid #ced4da !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  background: #fff;
}

/*********************** end el-tabs css *****************************/

.list-header .app-select .el-select .el-input__inner {
  display: block;
  width: 100%;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  height: calc(1.5em + 0.47rem + 0.75rem - 3px) !important;
}

.list-header .app-select .el-select .el-select__input {
  height: 36px;
}

.list-header .app-select .el-select {
  min-width: 100%;
}

.el-select-dropdown__item.selected {
  color: #556ee6 !important;
}

.app-post-loding .el-loading-spinner .path {
  stroke: #556ee6 !important;
}
.app-post-loding .el-loading-spinner .el-loading-text {
  color: #556ee6 !important;
  font-size: 15px;
}

.title-limit-desc {
  position: relative;
}

.title-limit-desc input {
  padding-right: 62px;
}

.title-limit-desc .number-of-word {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.7;
}

.list-date-picker {
  min-width: 207px !important;
  width: auto !important;
}

.list-date-picker input {
  display: block !important;
  width: 100% !important;
  padding: 0.47rem 0.75rem !important;
  font-size: 0.8125rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #495057 !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
  height: calc(1.5em + 0.54rem) !important;
}

.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.w-16-9-rem {
  height: 3rem;
  width: 5.33rem;
  object-fit: cover;
}
</style>
